import type { AddConversationMessageBodyRole } from './addConversationMessageBodyRole';

/**
 * 대화 메시지 저장 요청
 */
export type AddConversationMessageBody = {
  /** @nullable */
  completionTokens?: number | null;
  /** 메시지 내용 */
  content: string;
  /**
   * 사용된 모델 정보
   * @nullable
   */
  model?: string | null;
  /** @nullable */
  promptTokens?: number | null;
  /** 메시지 역할 */
  role: AddConversationMessageBodyRole;
  /** @nullable */
  totalTokens?: number | null;
};
